<template>
    <div>
        <modal :title="$t('Drivers.validate_drivers')" @close-request="$emit('closeModal')" closable>
            <div v-if="showGroupList">
                <table-element :fields="fieldsObj" :arrOfElement="groups" :sortSpacing="0" :isShowFilter="false"
                    class="card mx-2 mt-4" :sortable="false" :pageSize="1000" @updateFilterResults="updateFilterResults">
                    <template #body-content-desktop="content" >
                        <!-- files -->
                        <tr v-for="(item) in content.results" :id="item.id" :key="item.name"
                        class="table-element_hover text-center draggable-item">
                            <td>
                            <div class="item-with-handle">
                                <input @click="editGroup(item)" type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
                                <div style="text-align: center; width: 100%;">{{ item.name }}</div>
                                </div>
                            </td>
                        </tr>
                        </template>
                        <template #body-content-mobile="content">
                            <!-- files -->
                            <div v-for="(item) in content.results" :id="item.id" :key="item.id" class="card p-2  my-3 mx-2 draggable-item">
                                <h4 style="text-align: center;">{{ item.name }}</h4>
                                <div class="d-flex justify-content-center my-3">
                                <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                                </div>
                            </div>
                        </template>
                        <template #post-body-content>
                            <div class="mt-2">
                                <button @click="addGroup()" class="float-right btn btn-kne-orange m-1">
                                {{$t('WallFile.add_group')}}
                                </button>
                            </div>
                    </template>
                </table-element>
            </div>
            <div v-if="showAddGroup || showEditGroup" style="padding: 20px;">
                <div style="padding: 20px;">
                    <regular-input class="form-group" :value="groupName" @input="groupName = $event"
                    :placeholder="$t('Drivers.enter_name')" />
    
                    <multi-select class="zone-select" :options="driverFileOptions" :selected-options="selectedDriverFileOptions" @select="handleDriverFileSelect" :placeholder="$t('Drivers.select_driverfile')" />
                </div>

                <table-element v-if="showAddGroup || showEditGroup" :fields="driverFileObj" :arrOfElement="driverFiles" :sortSpacing="0" :isShowFilter="false" class="card mx-2 mt-4" :isDraggable="true" @updateFinalData="updateFinalData" :pageSize="1000" :sortable="false" :driversSort="true" :groupSort="true">
                    <template #body-content-desktop="content" >
                        <!-- Wallfiles -->
                        <tr v-for="(item) in content.results" :id="item.id" :key="item.name"
                        class="table-element_hover text-center draggable-item">
                        <td>
                            <div class="item-with-handle">
                            <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                            <div class="item-name nowrap" style="position: relative">
                                <span>{{ item.name }}</span>
                                <span ref="hoverIcon" id="hoverIcon" v-if="!checkIconText"
                                class="icon--hover" aria-hidden="true" @mouseenter="e => mouseMoveXY(e.driverX, e.driverY)"
                                @click="onClickCopy(text)">
                                <span class="fa fa-info-circle icon-color icon-background-color"
                                    :style="returnIconCSS"></span>
                                <div class="icon--tooltip tooltip-bottom tooltip-left" :style="{ width: getToolTipWidth(item) }" >
                                    <i class="text-width" v-html="renderedText(item)" />
                                </div>
                                </span>
                            </div>

                            </div>
                        </td>
                        </tr>
                    </template>

                    <template #post-body-content>
                        <div class="mt-2">
                        <button @click="saveGroup" class="float-right btn btn-kne-orange m-1">
                            {{ $t('OrderCurrent.modal.confirm') }}
                        </button>
                        <button @click="closeGroup()" class="float-right btn btn-danger m-1">{{
                            $t('OrderCurrent.modal.cancel') }}</button>
                        </div>
                    </template>
                </table-element>
            </div>
        </modal>
    </div>
</template>

<script>
import { db } from '../../../../firebase'
import { MultiSelect } from 'vue-search-select'
import regularInput from '../../basic-components/regularInput.vue'
import Modal from '../../interface-components/Modal.vue'
import TableElement from '../Table-component/Table-Element.vue'

export default {
    name: 'ValidateDriversModal',
    components: {
        Modal,
        regularInput,
        MultiSelect,
        TableElement
    },

    props: {
        arrOfDriverFile: {
            type: Array,
            required: true
        },
        isOpen: Boolean
    },

    data () {
        return {
            // renderDriverFiles: false,
            groups: [],
            groupName: '',
            initialGroupName: '',
            groupId: '',
            showGroupList: true,
            showAddGroup: false,
            showEditGroup: false,
            driverFiles: [],
            driverFileOptions: [],
            selectedDriverFileOptions: [],
            isFeedbackPlay: false,
            mouseX: 270,
            mouseY: 550,
            fieldsObj: [
                {
                    text: this.$t('Drivers.group_name'),
                    type: 'name',
                    value: ''
                }
            ],
            driverFileObj: [
                {
                    text: this.$t('Drivers.driver_name'),
                    type: 'name',
                    value: ''
                }
            ],
            zones: [],
            adminData: [],
            finalData: this.arrOfDriverFile.slice().toReversed() || [],
            isLoading: true,
            groupListener: null
        }
    },

    async mounted () {
        this.getGroups()
        this.isLoading = false
        this.driverFileOptions = Object.entries(this.arrOfDriverFile).map(([id, df]) => ({
            value: df.id,
            text: df.name
        }))
        this.driverFileOptions.sort((a, b) => a.text - b.text)
    },

    beforeDestroy () {
      if (this.groupListener) {
        db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').off('value', this.groupListener)
      }
    },

    methods: {
        mouseMoveXY (x, y) {
            if (!this.displayFixed) return
            this.mouseX = x
            this.mouseY = y
        },
        async getGroups () {
            this.groupListener = await db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').on('value', (snapshot) => {
                if (!snapshot.exists()) {
                this.groups = []
                return
                }
                this.groups = Object.entries(snapshot.val()).map(([id, zoneData]) => ({
                    id,
                    ...zoneData
                }))
            })
        },
        handleDriverFileSelect (list) {
        this.selectedDriverFileOptions = list
        const selectedFileIds = new Set(list.map(item => item.value))
        if (this.driverFiles.length > list.length) { // Remove case
            this.driverFiles = this.driverFiles.filter(df =>
                selectedFileIds.has(df.id)
            )
        } else { // Add case
            const currentFileIds = new Set(this.driverFiles.map(df => df.id))
            const newlySelectedFiles = list.filter(item =>
                !currentFileIds.has(item.value)
            )
            newlySelectedFiles.forEach(newFile => {
                const fileToAdd = this.arrOfDriverFile.find(df => df.id === newFile.value)
                if (fileToAdd) {
                    const newDriverFile = {
                        ...fileToAdd,
                        index: 1000 + this.driverFiles.length
                    }
                    this.driverFiles.push(newDriverFile)
                }
            })
        }
        this.finalData = this.driverFiles
    },
        updateFilterResults (sortResults) {
            this.filterResults = sortResults
        },
        updateFinalData (newData) {
            this.finalData = newData
        },
        /** Remove unecessary spaces */
        trimSpaces (text) {
            if (!text) return text

            text = text.replace(/ {2}/g, '')
            text = text.trim()

            return text
        },

        /** Remove unecessary characters */
        trimSpecialChars (text) {
            text = text.replace(/<.*>/g, '')

            return text
        },
        renderedText (item) {
            if (this.isFeedbackPlay) return this.$t('hoverToolTip.copied')
            else return this.trimSpaces(this.getToolTipData(item))
        },
        getToolTipWidth (wallFileItem) {
            // minimum tooltop width
            let pickZonesCh = 20
            let dropZonesCh = 20
            // if tooltip has max width then make it wrap the text
            if (wallFileItem.pickZonesByName) {
            pickZonesCh = wallFileItem.pickZonesByName.join(', ').length
            if (pickZonesCh > 90) {
                return '37vw'
            }
            }
            if (wallFileItem.dropZonesByName) {
            dropZonesCh = wallFileItem.dropZonesByName.join(', ').length
            if (dropZonesCh > 90) {
                return '37vw'
            }
            }
            // else choose width based on the number of characters
            if (pickZonesCh > dropZonesCh) {
            return `${(pickZonesCh + 2) * 2}ch`
            }
            return `${(dropZonesCh + 2) * 2}ch`
        },
        getToolTipData (wallFileItem) {
            let text = ''
            text += `<div"><strong>${this.$t('WallFile.pick_zone')}:</strong></div>`
            text += wallFileItem.pickZonesByName ? `<p>${wallFileItem.pickZonesByName.join(', ') || '-'}</p>` : '<p>All</p>'
            text += `<br>`
            text += `<div"><strong>${this.$t('WallFile.drop_zone')}:</strong></div>`
            text += wallFileItem.dropZonesByName ? `<p>${wallFileItem.dropZonesByName.join(', ') || '-'}</p>` : '<p>All</p>'
            return text
        },
        getDrivers () {
            this.$bindAsArray('drivers', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
                this.getDriverFiles()
            })
        },
        getDriverFiles () {
            db.ref('database/driverfiles/transporter').child(this.companyUID).child('driverfile').once('value', (snapshot) => {
                const driverFilesData = snapshot.val() || {}
                let index = 10000000
                this.driverFiles = Object.entries(driverFilesData).map(([id, data]) => {
                    index++
                    const driverFilter = this.drivers.filter(driver => driver['.key'] === data.driver)
                    const driverInfo = driverFilter ? driverFilter[0] : {}
                    return {
                        id,
                        ...data,
                        data: driverInfo,
                        index: data.index || index,
                        priority: data.index || index,
                        driverName: driverInfo ? driverInfo.name : ''
                    }
                })
                this.driverFiles.sort((a, b) => a.priority - b.priority)
                this.getOrderForUser()
                this.getOrders()
            })
            .catch(error => {
                confirm('Unable to fetch driver files')
                console.error('Error fetching driver files:', error)
            })
        },
        editGroup (group) {
            this.showGroupList = false
            this.showAddGroup = false
            this.driverFiles = this.arrOfDriverFile.filter(df => group.driverFiles[df.id])
            this.driverFiles.forEach(df => {
                df.index = group.driverFiles[df.id]
            })
            this.groupName = group.name
            this.initialGroupName = group.name
            this.groupId = group.id
            this.selectedDriverFileOptions = this.driverFileOptions.filter(o => this.driverFiles.find(df => df.name === o.text))
            this.finalData = this.driverFiles
            this.driverFiles.sort((a, b) => a.index - b.index)
            this.showEditGroup = true
        },
        addGroup () {
            this.showGroupList = false
            this.showEditGroup = false
            this.showAddGroup = true
            this.groupName = ''
            this.wallFiles = []
            this.finalData = []
            this.s = []
        },
        saveGroup () {
            if (!this.groupName) {
                confirm('Please enter group name')
                return
            }
            if (!this.selectedDriverFileOptions || !this.selectedDriverFileOptions.length) {
                confirm('Please select driverfile')
                return
            }
            if (this.showEditGroup && this.groupName !== this.initialGroupName && this.sameGroupName(this.groupName)) {
                console.log({initial: this.initialGroupName})
                confirm('Group Name already exists')
                return
            }
            if (!this.showEditGroup && this.sameGroupName(this.groupName)) {
                confirm('Group Name already exists')
                return
            }
            this.finalData.forEach((item, index) => {
                item.index = (index + 1000)
            })
            const newData = this.finalData
            let obj = {}
            newData.forEach(e => {
                obj[e.id] = e.index
            })
            if (this.showEditGroup) {
                this.updateGroup(obj)
                return
            }
            this.createGroup(obj)
        },
        sameGroupName () {
            return this.groups.some(group => group.name === this.groupName)
        },
        createGroup (obj) {
            db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').push().set(
                {
                name: this.groupName,
                driverFiles: obj
                }
            ).then(() => {
                console.log('Group saved')
                this.groupName = ''
                this.driverFiles = []
                this.selectedDriverFileOptions = []
                this.$emit('closeModal')
            }).catch(function (error) {
                confirm('Error adding driver file')
                console.error(error)
            })
        },
        updateGroup (obj) {
            db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').child(this.groupId).update(
                {
                name: this.groupName,
                driverFiles: obj
                }
            ).then(() => {
                console.log('Group updated')
                this.groupName = ''
                this.driverFiles = []
                this.selectedDriverFileOptions = []
                this.$emit('closeModal')
            }).catch(function (error) {
                confirm('Error adding driver file')
                console.error(error)
            })
        },
        closeGroup () {
            this.showAddGroup = false
            this.showEditGroup = false
            this.showGroupList = true
            this.groupName = ''
            this.driverFiles = []
            this.selectedDriverFileOptions = []
        }
    },

    computed: {
        companyUID () {
          return this.$store.state.authorization.company
        },
        checkIconText () {
            if (this.iconText === false || this.iconText === '' || typeof this.iconText === 'undefined') return false
            else return true
        },
        returnIconCSS () {
            return {
                '--icon-color': this.iconColor,
                '--icon-background-color': this.iconBackgroundColor
            }
        },
        returnToolTipPosition () {
            return {
                'position': 'fixed',
                'top': (this.mouseY) + 'px',
                'left': (this.mouseX) + 'px'
            }
        }
    }
}
</script>

<style scoped>
    .active-tab{
      font-weight: bold;
      color:black;
   }
   .modal-container{
     display: flex;
     gap:1rem;
    }
  
   .item-with-handle{
    display: flex;
   }
   .item-name{
    margin-inline:auto;
   }
   .wallfile-pickupzone-card{
    margin: 0.5rem 0.5rem 0 0.5rem;
    border-bottom:1px solid #F0F0F0; 
    padding-bottom:.125rem;
   }

  .icon--hover {
    color: #f7941e;
    position: relative;
    text-align: center;
  }

  .icon--hover .icon--tooltip {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8rem;
    background: #e88b1a;
    border-radius: 3px;
    color: white;
    margin-bottom: 10px;
    opacity: 0;
    padding: 8px;
    pointer-events: none;
    text-wrap: wrap;
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all .25s ease-out;
    -moz-transition: all .25s ease-out;
    -ms-transition: all .25s ease-out;
    -o-transition: all .25s ease-out;
    transition: all .25s ease-out;
    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  }
  .icon--tooltip {
    position: absolute;
    z-index: 999999;
  }
  
  .tooltip-bottom {
    top: 80%;
  }
  .tooltip-left {
    left: 0%;
  }

  .strong {
    font-weight: 900;
  }
  .icon--hover:hover .icon--tooltip {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  .background-thing {
    font-size: 0.8rem;
    background-color: rgb(255, 255, 255);
    border-radius: 5rem;
    padding: 0.25rem 0.25rem 0.25rem 0.25rem;
  }

  .icon-color {
    color: var(--icon-color);
  }

  .icon-background-color {
    background-color: var(--icon-background-color)
  }
  .zones {
    width: 30vw !important;
    display: flex;
    flex-wrap: nowrap
  }
  .zone-names {
    width: 95%;
    overflow: hidden; 
    white-space: nowrap; 
    text-overflow: ellipsis;
  }
  .zones {
    width: 30%;
  }
  .df {
    display: flex;
    flex-wrap: nowrap;
  }
  .clip-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  } 
  .tooltip-div {
    margin-left: auto;
  }
</style>
